import React from "react";

const Textarea = (props) => {
  let invalidFields = props.invalidFields;
  return (
    <div className={invalidFields.includes(props.name) ? "invalid" : ""}>
      {props.label ? (
        <label className={props.required ? "required" : ""}>
          {props.label}
        </label>
      ) : null}
      <textarea
        name={props.name}
        value={props.value}
        maxLength={props.maxLength}
        placeholder={props.placeholder}
        onChange={props.onChange}
      ></textarea>
    </div>
  );
};

export default Textarea;
